import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/components/site/Reveal";

export default function NotFound() {
  usePageMeta("Page Not Found — SKN Group of Companies", "The page you are looking for could not be found.");

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      data-testid="not-found-page"
    >
      <div className="text-center max-w-lg">
        <p className="font-display text-8xl md:text-9xl font-medium tracking-tight bronze italic">404</p>
        <h1 className="mt-6 font-display text-3xl md:text-4xl font-medium tracking-tight">
          This page doesn't exist
        </h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Like an unwritten chapter of our journey, this page is yet to be found.
          Let us take you back home.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-10 inline-flex items-center gap-2 bg-foreground text-background px-8 py-4 text-sm font-medium hover:bg-[#B8997A] hover:text-[#0B0F14] transition-colors duration-300"
        >
          <ArrowLeft size={16} strokeWidth={1.5} /> Back to Home
        </Link>
      </div>
    </div>
  );
}
